<template>
  <div class="user">
    <m-header></m-header>
    <div class="userOperate">
      <el-input v-model="keywords" placeholder="搜索"></el-input>
      <el-button @click="export2Excel" ref="exportData">导出为xls</el-button>
      <el-button @click="handleAdd" >添加众筹</el-button>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="pageChange"
        :total="totalNum"
        v-if="paginationShow">
      </el-pagination>
    </div>
    <div class="userTable">
      <el-table
      ref="multipleTable"
      :data="raiseDatas"
      tooltip-effect="dark"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="60">
      </el-table-column>
      <el-table-column
        prop="tranche"
        label="期数"
        width="80">
      </el-table-column>
      <el-table-column
        prop="round"
        label="轮次"
        width="80">
      </el-table-column>
      <el-table-column
        prop="insertTime"
        label="创建时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="startDate"
        label="开始时间"
        width="120">
      </el-table-column>
      <el-table-column
        prop="endDate"
        label="结束时间"
        width="120">
      </el-table-column>
      <el-table-column
        prop="totalPortion"
        label="数额要求"
        width="120">
      </el-table-column>
      <el-table-column
        prop="unitPrice"
        label="每份单价"
        width="100">
      </el-table-column>
      <el-table-column
        prop="nowPortion"
        :formatter="handleCellValue"
        label="完成度"
        width="120">
      </el-table-column>
      <el-table-column
        prop="sumPeopleNumber"
        label="参与人数"
        width="100">
      </el-table-column>
      <el-table-column label="操作"
        show-overflow-tooltip>
         <template slot-scope="scope">
           <!-- <el-button
             size="mini"
             @click="handleAddRound(scope.$index, scope.row)">增加轮次</el-button> -->
           <el-button
             size="mini"
             @click="handleDetail(scope.$index, scope.row)">详情</el-button>
         </template>
       </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="detailTitle"
      :visible.sync="detailDialogVisible"
      width="80%"
      border
      :append-to-body=true>
      <el-table :data="roundDatas">
        <el-table-column
          prop="round"
          label="轮次"
          width="60">
        </el-table-column>
        <el-table-column
          prop="insertTime"
          label="创建时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="startDate"
          label="开始时间"
          width="100">
        </el-table-column>
        <el-table-column
          prop="endDate"
          label="结束时间"
          width="100">
        </el-table-column>
        <el-table-column
          prop="totalPortion"
          label="数额要求"
          width="100">
        </el-table-column>
        <el-table-column
          prop="unitPrice"
          label="每份单价"
          width="80">
        </el-table-column>
        <el-table-column
          prop="nowPortion"
          :formatter="handleCellValue"
          label="完成度"
          width="100">
        </el-table-column>
        <el-table-column
          prop="sumPeopleNumber"
          label="参与人数"
          width="80">
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="目标总金额"
          width="120">
        </el-table-column>
        <el-table-column
          prop="nowAmount"
          label="已完成金额"
          width="120">
        </el-table-column>
        <el-table-column
          prop="state"
          :formatter="handleStatusValue"
          label="状态"
          width="80">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="添加众筹"
      :visible.sync="addDialogVisible"
      width="40%"
      center
      :append-to-body=true>
      <el-form :label-position="left" label-width="80px" :model="addData" :rules="rules" ref="addForm">
        <el-form-item label="开始时间" prop="startDate">
          <el-date-picker type="date" placeholder="选择日期" v-model="addData.startDate" style="width: 100%;"></el-date-picker>
        </el-form-item>
      <!--  <el-form-item label="结束时间" prop="endDate">
          <el-date-picker type="date" placeholder="选择日期" v-model="addData.endDate" style="width: 100%;"></el-date-picker>
        </el-form-item> -->
        <el-form-item label="数额要求" prop="totalPortion">
          <el-input-number v-model="addData.totalPortion" @change="handleChange" :min="1" :max="10000" label="描述文字"></el-input-number>
        </el-form-item>
       <!-- <el-form-item label="每份单价" prop="unitPrice">
          <el-input-number v-model="addData.unitPrice" @change="handleChange" :min="1" :max="10000" label="描述文字"></el-input-number>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addRaise('addForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog
      title="添加轮次"
      :visible.sync="addRoundDialogVisible"
      width="40%"
      center
      :append-to-body=true>
      <el-form :label-position="left" label-width="80px" :model="roundData">
        <el-form-item label="开始时间">
          <el-input v-model="roundData.startDate"></el-input>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-input v-model="roundData.endDate"></el-input>
        </el-form-item>
        <el-form-item label="数额要求">
          <el-input v-model="roundData.totalPortion"></el-input>
        </el-form-item>
        <el-form-item label="每份单价">
          <el-input v-model="roundData.unitPrice"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addRoundDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addRound()">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MHeader from 'components/header/header'
import {getAllRaise, addRaise, addRound,getRounds} from 'api/request'
import {ERR_OK} from 'api/config'
import {formatDate, loadingInstance, Success, Error} from 'common/js/util'
export default {
  components: { MHeader },
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      keywords: null,
      addDialogVisible: false,
      addRoundDialogVisible: false,
      detailDialogVisible: false,
      left: "left",
      detailTitle: "期数：1",
      addData: {},
      controlData: {},
      roundDatas: [],
      raiseDatas: [],
      multipleSelection: [],
      addData: {
        startDate: new Date(),
        /* endDate: new Date(), */
        totalPortion: 100
        /* ,unitPrice: 100 */
      },
      rules: {
        startDate: [
          { type: 'date', required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        /* endDate: [
          { type: 'date', required: true, message: '请选择结束时间', trigger: 'change' }
        ], */
        totalPortion: [
          { type: 'number', required: true, message: '请输入数额要求', trigger: 'blur' },
        ]/* ,
        unitPrice: [
          { type: 'number', required: true, message: '请输入每份单价', trigger: 'blur' },
        ] */
      }
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this._getList();
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChange (val) {
      console.log(val)
      this.pageNum = val
      this._getList()
    },
    handleCellValue(row, column, cellValue, index) {
      if (!cellValue) {
        cellValue = 0;
      }
      return cellValue*100/this.raiseDatas[index].totalPortion+'%'
    },
    handleStatusValue(row, column, cellValue, index) {
      //"state": 0,					//状态  -1未开始   0.进行中   1.成功  2.失败
      switch(cellValue){
         case -1:
          return "未开始";
         case 0:
          return "进行中";
         case 1:
          return "成功";
         case 2:
          return "失败";
      }
    },
    handleChange(value) {
        console.log(value);
    },
    handleAdd() {
      this.addDialogVisible = true;
    },
    handleAddRound(index, row) {
      this.addRoundDialogVisible = true;
      this.controlData = this.raiseDatas[index];
    },
    handleDetail(index, row) {
      this.detailDialogVisible = true;
      this.controlData = this.raiseDatas[index];
      this.detailTitle = "期数："+this.controlData.tranche;
      this.roundDatas = [this.controlData];
    },
    //添加众筹
   addRaise(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            startDate: formatDate(this.addData.startDate),
           /* endDate: formatDate(this.addData.endDate), */
            totalPortion: this.addData.totalPortion
            /* ,unitPrice: this.addData.unitPrice */
          }
          loadingInstance(Loading);
          addRaise(param).then((res) => {
            loadingInstance(Loading).close()
            if (res.status === ERR_OK) {
              this.addDialogVisible = false;
              this.addData = {
                startDate: new Date(),
                endDate: new Date(),
                totalPortion: 100,
                unitPrice: 100
              }
              this._getList();
            } else {
              Error(this, res);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //添加轮次
    addRound(){
      let param = {
        userid: getUserInfo.userid,
        roundData: this.roundData,
        //todo
      }
      loadingInstance(Loading);
      addRound(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          _getList();
        } else {
          Error(this, res);
        }
      })
    },
    _getList () {
      let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
      let param = {
        keywords: this.keywords,
        current: this.pageNum,
        size: this.pageSize
      }
      loadingInstance(Loading)
      getAllRaise(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.raiseDatas = res.data.records
          this.totalNum = res.data.total
          if(res.data.pages>1){
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    },
    export2Excel() {
      var exportList = this.multipleSelection;
      let arr = []
      for (var i = 0; i < exportList.length; i++) {
        let obj = {}
        obj.tranche = exportList[i].tranche
        obj.round = exportList[i].round
        obj.insertTime = exportList[i].insertTime
        obj.startDate = exportList[i].startDate
        obj.endDate = exportList[i].endDate
        obj.totalPortion = exportList[i].totalPortion
        obj.unitPrice = exportList[i].unitPrice
        obj.finish = exportList[i].nowPortion*100/exportList[i].totalPortion+'%'
        obj.sumPeopleNumber = exportList[i].sumPeopleNumber
        arr.push(obj)
      }
      require.ensure([], () => {
        const {exportJsonToExcel} = require('../../vendor/Export2Excel')
        const tHeader = ['期数', '轮次', '创建时间','开始时间', '结束时间', '数额要求', '每份单价', '完成度', '参与人数']
        const filterVal = ['tranche', 'round', 'insertTime','startDate', 'endDate', 'totalPortion', 'unitPrice', 'finish', 'sumPeopleNumber']
        const list = arr
        const data = this.formatJson(filterVal, list)
        exportJsonToExcel(tHeader, data, '众筹列表')
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  },
}
</script>
<style scoped>
    .user{
      z-index: 9;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #F8F8F8;
    }
   .userOperate{
     height: 50px;
     margin-left: 100px;
     margin-right: 100px;
     margin-top: 30px;
     margin-bottom: 10px;
     box-sizing: border-box;
   }
   .userTable{
     padding-left: 100px;
     padding-right: 100px;
     position: relative;
   }
</style>
<style>
  .userOperate .el-input {
    width:180px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }
  .userOperate .el-button {
    width:100px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/raise/raise.vue